<app-upload [uploadFn]="uploadFn" />

<app-multimedia-grid-layout>
  @for (item of uploadQueue(); track item.name) {
    <app-multimedia-grid-layout-item>
      <app-multimedia-tile mode="loading" />
    </app-multimedia-grid-layout-item>
  }
  @for (item of uploaded(); track item.id) {
    <app-multimedia-grid-layout-item>
      <app-multimedia-tile
        [info]="shouldShowInfo(item)"
        [type]="item.type"
        [alt]="item.alt"
        [filename]="item.filename"
        [size]="item.size"
        [previewUrl]="item.thumbnailPreviewUrl"
        [extension]="item.extension"
        mode="preview" />
    </app-multimedia-grid-layout-item>
  }
</app-multimedia-grid-layout>
